var _excluded = ["complete"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useState, useEffect } from 'react';
import { PaymentRequestButtonElement, useStripe } from '@stripe/react-stripe-js';
import { noop } from "../../utils";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 * Stripe PaymentRequestButton component
 */
var PaymentRequestButton = _ref => {
  var {
    amount,
    capture: {
      email: captureEmail,
      name: captureName,
      phone: capturePhone
    },
    countryCode,
    currency,
    description,
    lineItems,
    onLoaded = noop,
    onPaymentMethodCaptureFailed,
    onPaymentMethodCaptured,
    onPaymentMethod,
    onShippingAddressChange,
    onShippingOptionChange,
    requestShipping,
    shippingOptions,
    theme,
    type
  } = _ref;
  var [paymentRequest, setPaymentRequest] = useState();
  var stripe = useStripe();
  useEffect(() => {
    if (stripe) {
      var _paymentRequest = stripe.paymentRequest({
        country: countryCode,
        currency: currency.toLowerCase(),
        requestPayerEmail: captureEmail,
        requestPayerName: captureName,
        requestPayerPhone: capturePhone,
        requestShipping,
        shippingOptions,
        total: {
          amount: 0,
          label: ' '
        }
      });
      setPaymentRequest(undefined);
      _asyncToGenerator(function* () {
        var result = yield _paymentRequest.canMakePayment();
        if (result) {
          _paymentRequest.on('paymentmethod', /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(function* (_ref3) {
              var {
                  complete
                } = _ref3,
                event = _objectWithoutPropertiesLoose(_ref3, _excluded);
              var {
                errored = false,
                paymentIntent
              } = yield onPaymentMethod(event);
              if (errored || !paymentIntent) {
                complete('fail');
              } else {
                complete('success');
                var {
                  clientSecret,
                  status
                } = paymentIntent;
                if (status === 'requires_action') {
                  var {
                    error
                  } = yield stripe.confirmCardPayment(clientSecret);
                  if (error) {
                    onPaymentMethodCaptureFailed();
                  } else {
                    onPaymentMethodCaptured();
                  }
                } else {
                  onPaymentMethodCaptured();
                }
              }
            });
            return function (_x) {
              return _ref4.apply(this, arguments);
            };
          }());
          if (onShippingOptionChange) {
            _paymentRequest.on('shippingoptionchange', _ref5 => {
              var {
                shippingOption,
                updateWith
              } = _ref5;
              onShippingOptionChange(shippingOption, updateWith);
            });
          }
          if (onShippingAddressChange) {
            _paymentRequest.on('shippingaddresschange', _ref6 => {
              var {
                shippingAddress,
                updateWith
              } = _ref6;
              onShippingAddressChange(shippingAddress, updateWith);
            });
          }
          setPaymentRequest(_paymentRequest);
          onLoaded(true);
        } else {
          onLoaded(false);
        }
      })();
    }
  }, [countryCode, currency, lineItems, onLoaded, onPaymentMethodCaptureFailed, onPaymentMethodCaptured, onPaymentMethod, onShippingAddressChange, shippingOptions, stripe]);
  useEffect(() => {
    if (paymentRequest) {
      paymentRequest.update({
        total: {
          amount,
          label: description
        }
      });
    }
  }, [amount, description, paymentRequest]);
  if (paymentRequest) {
    return ___EmotionJSX(PaymentRequestButtonElement, {
      options: {
        paymentRequest,
        style: {
          paymentRequestButton: {
            theme,
            type
          }
        }
      }
    });
  }
  return null;
};
export default PaymentRequestButton;